export default __webpack_public_path__ + "e79d32bc1a572c0e47c356b1c508f278.svg";